import React from 'react'

import SessionCustomField from "../../../model2/custom-field/session-custom-field"
import ItemId from "../../../gd-ui/id/item-id"

type Props = {
    customField: SessionCustomField
}

export default function CustomFieldId(props: Props) {
    if (!props.customField || !props.customField.id) {
        return null
    }

    return (
        <div className="details-item">
            <div className="label-details ui5-txt-not-important-tiny">System ID:</div>
            <div className="value ui5-txt-default flex-r fl-ac">
                <ItemId className   = "m-r-15"
                        renderType  = "text"
                        itemId      = {props.customField.id}
                        itemName    = "System"
                        copyId      = {true}
                        copyUrl     = {false} />
            </div>
        </div>
    )
}
